module.exports = __webpack_public_path__ + "img/step-score-en.891f09c0.webp";